(function () {
  if (window.hoaPdpInfo) return;
  window.hoaPdpInfo = true;

  function openModal(modal) {
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.classList.add('is-open');
    document.body.classList.add('hoa-pdp-lock');
    var close = modal.querySelector('.hoa-pdp-modal__close');
    if (close) close.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('hoa-pdp-lock');
    modal.querySelectorAll('video').forEach(function (v) { v.pause(); });
  }

  document.addEventListener('click', function (e) {
    var why = e.target.closest('.hoa-pdp__why');
    document.querySelectorAll('.hoa-pdp__why.is-open').forEach(function (el) { if (el !== why) el.classList.remove('is-open'); });
    if (why) { why.classList.toggle('is-open'); return; }

    var opener = e.target.closest('[data-hoa-modal-open]');
    if (opener) {
      e.preventDefault();
      var modal = document.getElementById(opener.getAttribute('data-hoa-modal-open'));
      if (!modal) return;
      var src = opener.getAttribute('data-video-src');
      if (src) {
        var video = modal.querySelector('video');
        if (video.getAttribute('src') !== src) video.setAttribute('src', src);
        var poster = opener.getAttribute('data-video-poster');
        if (poster) video.setAttribute('poster', poster);
        openModal(modal);
        video.currentTime = 0;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        openModal(modal);
      }
      return;
    }

    if (e.target.closest('.hoa-pdp-modal__close') || e.target.classList.contains('hoa-pdp-modal')) {
      closeModal(e.target.closest('.hoa-pdp-modal'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.hoa-pdp-modal.is-open').forEach(closeModal);
  });

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest('.hoa-pdp__video-open');
    if (!card) return;
    var v = card.querySelector('video');
    if (v && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('.hoa-pdp__video-open');
    if (!card || card.contains(e.relatedTarget)) return;
    var v = card.querySelector('video');
    if (v) v.pause();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.hoa-pdp-notify__form');
    if (!form) return;
    e.preventDefault();
    var msg = form.parentElement.querySelector('.hoa-pdp-notify__msg');
    var btn = form.querySelector('button');
    btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function () {
        form.hidden = true;
        if (msg) msg.textContent = form.getAttribute('data-success');
      })
      .catch(function () { btn.disabled = false; });
  });
})();

(function () {
  if (window.hoaPdpBlocks) return;
  window.hoaPdpBlocks = true;
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var monthsLong = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function ord(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
  function add(d) { var x = new Date(); x.setDate(x.getDate() + (parseInt(d, 10) || 0)); return x; }
  function short(d) { return months[d.getMonth()] + ' ' + ord(d.getDate()); }

  function init(root) {
    root.querySelectorAll('[data-hoa-date-from]').forEach(function (el) {
      var f = el.getAttribute('data-hoa-date-from'), t = el.getAttribute('data-hoa-date-to');
      el.textContent = (t !== '' && t !== f) ? short(add(f)) + ' - ' + short(add(t)) : short(add(f));
    });
    root.querySelectorAll('[data-hoa-date-long]').forEach(function (el) {
      var d = add(el.getAttribute('data-hoa-date-long'));
      el.textContent = days[d.getDay()] + ', ' + monthsLong[d.getMonth()] + ' ' + ord(d.getDate());
    });
    root.querySelectorAll('[data-hoa-offers]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var sync = function () {
        var input = box.querySelector('input[type=radio]:checked');
        if (!input) return;
        box.querySelectorAll('.hoa-offers__bar').forEach(function (b) { b.classList.toggle('is-selected', b.contains(input)); });
        var form = document.getElementById(box.dataset.form);
        if (form) {
          var id = form.querySelector('input[name=id]');
          if (id && input.dataset.variant) { id.value = input.dataset.variant; id.disabled = false; }
        }
        var q = box.querySelector('[data-hoa-offer-qty]') || document.getElementById(box.dataset.qty);
        if (q && box.dataset.mode === 'quantity') q.value = input.dataset.qty;
      };
      box.addEventListener('change', sync);
      sync();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hoa-tab]');
    if (!btn) return;
    var wrap = btn.closest('[data-hoa-tabs]');
    wrap.querySelectorAll('[data-hoa-tab]').forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
    wrap.querySelectorAll('[data-hoa-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-hoa-panel') === btn.getAttribute('data-hoa-tab')); });
  });

  function tick() {
    document.querySelectorAll('[data-hoa-countdown]').forEach(function (el) {
      var cut = parseInt(el.getAttribute('data-cutoff'), 10) || 0;
      var now = new Date(), end = new Date(now);
      end.setHours(cut, 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var s = Math.floor((end - now) / 1000), h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var pill = el.querySelector('[data-hoa-countdown-pill]');
      if (pill) pill.textContent = pad(h) + ' Hrs ' + pad(m) + ' Mins ' + pad(sec) + ' Secs';
    });
  }

  var start = function () { init(document); tick(); setInterval(tick, 1000); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
(function () {
  if (window.__hoaStickyAtc) return;
  window.__hoaStickyAtc = true;
  var BADGE = '<svg viewBox="0 0 12 12" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0L.3 7.7a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"/></svg>';
  function setup(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var sid = bar.dataset.section;
    var form = document.getElementById('product-form-' + sid);
    var mainBtn = document.getElementById('ProductSubmitButton-' + sid) || (form && form.querySelector('[type=submit]'));
    var select = bar.querySelector('[data-hoa-sticky-select]');
    var addBtn = bar.querySelector('[data-hoa-sticky-add]');
    var variants = [];
    try { variants = JSON.parse(bar.querySelector('[data-hoa-sticky-variants]').textContent); } catch (e) {}
    var idInput = form && form.querySelector('input[name=id]');
    function find(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }
    function render(id) {
      var v = find(id);
      if (!v) return;
      var price = bar.querySelector('[data-hoa-sticky-price]');
      var html = '<span class="hoa-sticky-atc__sale">' + v.price + '</span>';
      if (v.compare) html += '<s class="hoa-sticky-atc__compare">' + v.compare + '</s><span class="hoa-sticky-atc__badge">' + BADGE + 'SAVE ' + v.save + '%</span>';
      if (price) price.innerHTML = html;
      var img = bar.querySelector('[data-hoa-sticky-img]');
      if (img && v.image) img.src = v.image;
      if (select && select.value !== String(id)) select.value = String(id);
      if (addBtn) addBtn.disabled = !v.available;
    }
    function current() { return idInput ? idInput.value : (select ? select.value : null); }
    if (select) select.addEventListener('change', function () {
      var id = select.value;
      var radio = document.querySelector('[data-hoa-offers] input[type=radio][data-variant="' + id + '"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (idInput) {
        idInput.value = id;
        idInput.disabled = false;
      }
      render(id);
    });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-hoa-offers]')) setTimeout(function () { render(current()); }, 0);
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      if (select && idInput && idInput.value !== select.value) { idInput.value = select.value; idInput.disabled = false; }
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
      else if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    });
    var anchor = mainBtn || form;
    function toggle() {
      if (!anchor) return;
      var show = anchor.getBoundingClientRect().bottom < 0;
      if (show !== bar.classList.contains('is-visible')) {
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) render(current());
      }
    }
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
    toggle();
  }
  function scan() { document.querySelectorAll('[data-hoa-sticky]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.hoa-pdp .product__accordion summary');
    if (!summary) return;
    var details = summary.parentElement, content = details.querySelector('.accordion__content');
    if (!content || !content.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    e.preventDefault();
    if (details._hoaAnim) details._hoaAnim.cancel();
    var opening = !details.open, pb = getComputedStyle(content).paddingBottom;
    if (opening) details.open = true;
    var h = content.offsetHeight + 'px', shut = { height: '0px', paddingBottom: '0px', opacity: 0 }, full = { height: h, paddingBottom: pb, opacity: 1 };
    details.classList.add('is-animating');
    var anim = content.animate(opening ? [shut, full] : [full, shut], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' });
    details._hoaAnim = anim;
    anim.onfinish = function () { if (!opening) details.open = false; details.classList.remove('is-animating'); details._hoaAnim = null; };
    anim.oncancel = function () { details.classList.remove('is-animating'); };
  });
})();
